// Third Party
import * as React from 'react';
import Image from 'next/image';
import cx from 'classnames';

// Utils
import { PropertyType } from '@gql';

// UI
import { Typography } from '@components/typography';
import house from '../../../../../../public/assets/svg/property-type-icons/house.svg';
import apartment from '../../../../../../public/assets/svg/property-type-icons/apartment.svg';
import guestHouse from '../../../../../../public/assets/svg/property-type-icons/guest-house.svg';
import bedAndBreakfast from '../../../../../../public/assets/svg/property-type-icons/bed-and-breakfast.svg';
import boutiqueHotel from '../../../../../../public/assets/svg/property-type-icons/hotel.svg';
import { mapPropertyTypeToTitle } from './map-property-type-to-title';
import { Button } from '@components/button';

type Props = {
  propertyType: PropertyType;
  onClick: () => void;
  selected: boolean;
};

export const PropertySelectionCard: React.FC<Props> = ({
  propertyType,
  onClick,
  selected,
}) => {
  return (
    <div className="relative flex items-start">
      <Button
        key={propertyType}
        color="gray"
        variant="outlined"
        onClick={onClick}
        className={cx(
          'text-primary-dark',
          'border-primary-main',
          'rounded-2xl',
          'w-full',
          'h-full',
          'aspect-square',
          'flex',
          'flex-1',
          'flex-col',
          'items-center',
          'justify-center',
          'px-2',
          'bg-white',
          'hover:bg-primary-xlight',
          'hover:text-primary-dark',
          {
            'bg-primary-xlight': selected,
            'text-primary-dark': selected,
            'border-2': selected,
          }
        )}
      >
        <Image
          src={enumToSvgPropertyTypes(propertyType)}
          className="flex items-center pb-2 text-primary-main"
          alt="property type"
          width="35"
        />

        <Typography variant="body1" variantM="body1" component="p">
          {mapPropertyTypeToTitle(propertyType)}
        </Typography>
      </Button>
    </div>
  );
};

const enumToSvgPropertyTypes = (propertyType: PropertyType): string => {
  switch (propertyType) {
    case PropertyType.House:
      return house;
    case PropertyType.Apartment:
      return apartment;
    case PropertyType.GuestHouse:
      return guestHouse;
    case PropertyType.BoutiqueHotel:
      return boutiqueHotel;
    case PropertyType.BedAndBreakfast:
      return bedAndBreakfast;
  }
};
